import { useState, useEffect, useCallback, useRef } from 'react';

// Eventos que consideramos como actividad del usuario (constante fuera del componente)
const ACTIVITY_EVENTS = [
    'mousedown',
    'mousemove',
    'keypress',
    'scroll',
    'touchstart',
    'click',
    'keydown'
];

const useInactivityTimer = (timeoutDuration = 10000) => { // 20 segundos por defecto
    const [isInactive, setIsInactive] = useState(false);
    const timeoutRef = useRef(null);
    const isInactiveRef = useRef(false);

    // Función para resetear el timer - CORREGIDA
    const resetTimer = useCallback(() => {

        // Limpiar timer existente SIEMPRE
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }

        // Si estábamos inactivos, volver a activo
        if (isInactiveRef.current) {
            console.log('Volviendo de estado inactivo a activo');
            setIsInactive(false);
            isInactiveRef.current = false;
        }

        // Crear nuevo timer SIEMPRE
        timeoutRef.current = setTimeout(() => {
            console.log('Tiempo de inactividad alcanzado - mostrando pantalla de bienvenida');
            setIsInactive(true);
            isInactiveRef.current = true;
        }, timeoutDuration);
    }, [timeoutDuration]);

    // Función para detener completamente el timer (útil para pantallas específicas)
    const stopTimer = useCallback(() => {
        console.log('Deteniendo timer de inactividad');
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        if (isInactiveRef.current) {
            setIsInactive(false);
            isInactiveRef.current = false;
        }
    }, []);

    // Función para reanudar el timer
    const startTimer = useCallback(() => {
        console.log('Iniciando timer de inactividad');
        resetTimer();
    }, [resetTimer]);

    // Función manual para marcar como inactivo (útil para testing)
    const setInactiveManually = useCallback(() => {
        console.log('Forzando estado inactivo manualmente');
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        setIsInactive(true);
        isInactiveRef.current = true;
    }, []);

    // Configurar event listeners
    useEffect(() => {
        // Agregar event listeners
        ACTIVITY_EVENTS.forEach(event => {
            document.addEventListener(event, resetTimer, true);
        });

        // Iniciar el timer al montar el componente
        resetTimer();

        console.log('Event listeners configurados para:', ACTIVITY_EVENTS.join(', '));

        // Cleanup
        return () => {
            console.log('Limpiando event listeners y timer');
            ACTIVITY_EVENTS.forEach(event => {
                document.removeEventListener(event, resetTimer, true);
            });
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
                timeoutRef.current = null;
            }
        };
    }, [resetTimer]);

    // Cleanup al desmontar
    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
                timeoutRef.current = null;
            }
        };
    }, []);

    return {
        isInactive,
        resetTimer,
        stopTimer,
        startTimer,
        setInactiveManually // Para testing/debugging
    };
};

export default useInactivityTimer;